'use client';

import { storyblokEditable } from '@utils/storyblok/storyblokEditable';
import type { SiteSettingsData } from '@modules/site/types';

type ContactInformationProps = {
  _uid: string;
  component: 'ContactInformation';
  title?: string;
  contactInfo?: Partial<SiteSettingsData['contact']> & {
    instagram?: string;
    instagramUrl?: string;
  };
  [key: string]: any;
};

export function ContactInformation({
  contactInfo,
  title = 'Contactgegevens',
  ...props
}: ContactInformationProps) {
  const instagramUrl = contactInfo?.instagramUrl ?? contactInfo?.instagram;

  return (
    <div
      {...storyblokEditable(props)}
      className="space-y-6"
    >
      <h3 className="text-2xl font-heading text-primary">{title}</h3>

      <div className="space-y-4 text-primary">
        {contactInfo?.name && (
          <div>
            <p className="font-semibold text-primary">Naam</p>
            <p>{contactInfo.name}</p>
          </div>
        )}

        {contactInfo?.email && (
          <div>
            <p className="font-semibold text-primary">E-mail</p>
            <a
              className="transition-colors hover:text-secondary"
              href={`mailto:${contactInfo.email}`}
            >
              {contactInfo.email}
            </a>
          </div>
        )}

        {contactInfo?.phone && (
          <div>
            <p className="font-semibold text-primary">Telefoon</p>
            <a
              className="transition-colors hover:text-secondary"
              href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
            >
              {contactInfo.phone}
            </a>
          </div>
        )}

        {contactInfo?.city && (
          <div>
            <p className="font-semibold text-primary">Locatie</p>
            <p>{contactInfo.city}</p>
          </div>
        )}

        {instagramUrl && (
          <div>
            <p className="font-semibold text-primary">Instagram</p>
            <a
              className="transition-colors hover:text-secondary"
              href={instagramUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              @metliefdetrouwvideografie
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
